import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 eBliz Solutions. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
